import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { CheckOutlined } from '@ant-design/icons';

const useStyles = createUseStyles({
	sortDiv: {
		position: 'absolute',
		top: '48px',
		left: '-68px',
		height: '160px',
		width: '176px',
		cursor: 'pointer',
		zIndex: '10',
		backgroundColor: 'white',
		boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
		borderRadius: '10px',
	},
	sortOptions: {
		zIndex: '10',
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	sortItem: {
		border: '0',
		display: 'flex',
		paddingLeft: '38px',
		alignItems: 'center',
		width: '100%',
		height: '18%',
		backgroundColor: 'white',
		border: '0',
		fontSize: '14px',
		'&:hover': {
			backgroundColor: '#F0F0F0',
		},
	},
	checkIcon: {
		fontSize: '18px',
		marginRight: '6px',
	},
});

// sorting options shown in the dropdownmenu in sortDiv
const sortingOptions = [
	{ title: '*relevance', translation: 'modelSelectView.relevance', key: 1, isChecked: true },
	{ title: '*date descending', translation: 'modelSelectView.datede', key: 2, isChecked: false },
	{ title: '*date ascending', translation: 'modelSelectView.dateas', key: 3, isChecked: false },
	{ title: '*title descending', translation: 'modelSelectView.titlde', key: 4, isChecked: false },
	{ title: '*title ascending', translation: 'modelSelectView.titlas', key: 5, isChecked: false },
];

const OptionChecked = (value) => {
	sortingOptions.forEach((option) => {
		const newOption = option;
		newOption.isChecked = false;
	});
	sortingOptions[value - 1].isChecked = true;
};

const CustomSortButton = (props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const { sortOptions, sortCall, sortValue, anyModelPinned } = props;
	const [relevanceThere, setRelevanceThere] = useState(anyModelPinned);

	useEffect(() => {
		const firstSortOption = { title: '*relevance', translation: 'modelSelectView.relevance', key: 1, isChecked: true };
		const isRelevanceOptionThere = sortingOptions[0].title.includes('elevan');
		// add "sortoption relevance" if any model is pinned and the "sortoption relevance" is not there
		if (anyModelPinned) {
			if (!isRelevanceOptionThere) {
				sortingOptions.forEach((element) => {
					const newElement = element;
					newElement.key++;
					newElement.isChecked = false;
				});
				sortingOptions.unshift(firstSortOption);
				setRelevanceThere(true);
			}
		}
		// shift "sortoption relevance" if no model is pinned and the "sortoption relevance" is there
		else if (isRelevanceOptionThere) {
			sortingOptions.shift();
			sortingOptions.forEach((element) => {
				const newElement = element;
				newElement.key--;
				newElement.isChecked = false;
			});
			sortingOptions[0].isChecked = true;
			setRelevanceThere(false);
		}
	}, [anyModelPinned]);

	return (
		sortOptions && (
			<div className={classes.sortDiv} style={relevanceThere ? { height: '160px' } : { height: '128px' }}>
				<div className={classes.sortOptions}>
					{sortingOptions.map((option, index) => (
						<button
							key={sortingOptions[index].key}
							className={classes.sortItem}
							type='button'
							style={
								{
									fontWeight: sortingOptions[index].isChecked ? 'bold' : 'normal',
									paddingLeft: sortingOptions[index].isChecked ? '13px' : '38px',
									height: !relevanceThere ? '22%' : '18%',
								}

								// sortingOptions[index].isChecked ? { fontWeight: 'bold', paddingLeft: '13px' } : { fontWeight: 'normal' }
							}
							onClick={() => {
								OptionChecked(sortingOptions[index].key);
								if (sortingOptions[index].key === 3 || sortingOptions[index].key === 5) {
									sortValue(true);
								} else {
									sortValue(false);
								}
								if (anyModelPinned) {
									sortCall(sortingOptions[index].key);
								} else {
									sortCall(sortingOptions[index].key + 1);
								}
							}}
						>
							{sortingOptions[index].isChecked && <CheckOutlined className={classes.checkIcon} />}
							{t([sortingOptions[index].translation, sortingOptions[index].title])}
						</button>
					))}
				</div>
			</div>
		)
	);
};

export default CustomSortButton;
